import React from 'react';
import { playerAvatarImgClassName } from '../../../utils/avatarClassNames';

const FixedTeamBanner = ({ scrolledPastBanner, team, temperature }) => {
	if (!scrolledPastBanner || team.length === 0) return null;

	const { image_url, name, location } = team;

	return (
		<div className="fixed top-0 left-0 right-0 h-28 bg-white dark:bg-dark-card text-black dark:text-dark-text flex items-center justify-center border border-gray-300 dark:border-dark-border shadow-lg z-50">
			<div className="flex items-center">
				<div
					onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
					style={{ cursor: 'pointer' }}
					className="flex items-center"
				>
					<div className="relative mr-4">
						<img
							className={playerAvatarImgClassName}
							src={`${image_url}?w=75&h=75`}
							alt={`${name}`}
							style={{
								width: '75px',
								height: '75px'
							}}
						/>
					</div>
					<div>
						<div className="text-2xl font-bold">{name}</div>
						<div>
							<div className="text-lg text-gray-500 dark:text-gray-300">
								{`${location}`}
								{temperature !== null &&
									` • ${temperature.temp}\u00B0, ${temperature.weather}`}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FixedTeamBanner;
